import { FC } from "react";
import { IOptionSelect } from "src/@types/form";
import { Checkbox } from "../Checkbox";

interface Props {
  checked: boolean;
  option: IOptionSelect;
  onClick: VoidFunction;
}

export const CheckboxSelectorItem: FC<Props> = ({
  checked,
  option,
  onClick,
}) => (
  <div
    className="flex items-center justify-center gap-6 cursor-pointer text-sm md:text-base"
    onClick={onClick}
  >
    <Checkbox id={String(option.value)} checked={checked} />
    <span>{option.label}</span>
  </div>
);
